import Main from "./pages/Main";
import Error from "./pages/ErrorPage";
import Serie from "./pages/Serie";
import Mangi from "./pages/Mangi";
import Manga from "./pages/Manga";
import Chapters from "./pages/Chapters";
import Header from "./components/Header";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/series" element={<Main />} />
                <Route path="/series/:id" element={<Serie />} />
                <Route path="/mangi" element={<Mangi />} />
                <Route path="/mangi/:id" element={<Manga />} />
                <Route path="/mangi/:id/:chapter" element={<Chapters />} />
                <Route path="*" element={<Error />} />
            </Routes>
        </Router>
    );
}

export default App;
